
import { Component, input, InputSignal, model } from '@angular/core';
import { FikoYTKokBilesenComponent } from '../../../../kok-bilesen/kok-bilesen.component';
import { IKart } from '../../../interfaces/IKart.interface';


@Component({
  selector: 'fikoyt-kart',
  standalone: true,
  imports: [],
  templateUrl: "./fikoyt-kart.component.html",
  // styleUrl: "./fikoyt-uygulama-baslik.component.scss",

})
export class FikoYTKartComponent extends FikoYTKokBilesenComponent {
  kart: InputSignal<IKart<any>> = input(null);

  constructor() {
    super();

  }

}
